<template>
  <div>
    <van-popup
      v-model="showCities"
      position="bottom"
    >

      <div style="width: 92%;height: 95%;margin-left: 15px;margin-top: 15px;">

        <!-- 标题 -->
        <div style="text-align: center;font-size: 20px;font-weight: 500;">
          选择站点
        </div>
        <!-- /标题 -->

        <div class="roll">
          <!-- 可选站点 -->
          <div
            v-for="(item,index) in citys"
            :key="index"
          >
            <van-cell-group>
              <van-cell :title="index" />
            </van-cell-group>
            <div class="town">
              <div
                v-for="(item2,index2) in item"
                :key="index2"
                style="display: inline-block;margin-top: 10rpx;"
                @click="onConfirm(item2)"
              >
                <van-tag
                  :color="city===item2?'#FF9900':'#ffffff'"
                  :text-color="city===item2?'#ffffff':'#999999'"
                >{{item2}}</van-tag>

              </div>
            </div>

          </div>
          <!-- /可选站点 -->

        </div>
      </div>
      <!-- <van-picker ref="thePicker"  :columns="columns" @change="onChange" @confirm="onConfirm"  show-toolbar
		title="选择城市站点"  @cancel="showCities=false"   swipe-duration="500"/> -->
    </van-popup>
  </div>
</template>
<style  scoped>
</style>
<script>
import { mapState, mapGetters } from 'vuex'
import axios from '../../http.js'
import store from '../../store.js'
export default {
  props: ['siteDetail'],
  computed: {
    ...mapState(['token', 'site']),
    ...mapGetters(['hasLogin']),
  },
  data() {
    return {
      cityChecker: 1,
      showCities: false,
      columns: [],
      levelOne: 0,
      levelTow: 0,
      citys: '',
      city: '',
    }
  },
  methods: {
    // chooseIndex(site) {
    //   let sheng_index = 0,
    //     shi_index = 0
    //   var j = 0,
    //     sheng_name = ''
    //   for (let i in this.citys) {
    //     for (let k in this.citys[i]) {
    //       if (this.citys[i][k] == site) {
    //         shi_index = k
    //         sheng_index = j
    //         sheng_name = i
    //         break
    //       }
    //     }
    //     j++
    //   }
    //   this.columns[0].defaultIndex = parseInt(sheng_index)
    //   this.columns[1].values = this.citys[sheng_name]
    //   this.columns[1].defaultIndex = parseInt(shi_index)
    // },
    // onChange(picker, values) {
    //   picker.setColumnValues(1, this.citys[values[0]])
    // },
    onConfirm(values) {
      console.log(values)
      this.$emit('onSelected', values)
      this.showCities = false
    },
    show() {
      this.showCities = true
    },
    loadCity() {
      const that = this
      try {
        that.$axios.get('site/list').then((res) => {
          if (res.data.code == 200) {
            that.citys = res.data.data

            that.columns = [
              {
                values: Object.keys(res.data.data),
                className: 'column1',
              },
              {
                values: res.data.data['浙江'],
                className: 'column2',
              },
            ]
          }
          // }else{
          // 	let data={'浙江': ['杭州']};
          // 	that.$store.commit('SET_ALLSITE',JSON.stringify(res.data.data));
          // }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
    checkIp() {
      const that = this
      try {
        that.$axios.get('site/local').then((res) => {
          if (res.data.code == 200) {
            let city = res.data.data.city
            if (city) {
              setTimeout(function () {
                that.$dialog
                  .confirm({
                    title: '提示',
                    message: '系统定位到您所在城市:' + city + '是否切换?',
                  })
                  .then(() => {
                    that.$store.commit('ChangeSite', city)
                    // that.chooseIndex(that.site)
                  })
              }, 1500)
            }
          }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
  },
  mounted() {
    if (!this.token && !localStorage.site) {
      this.checkIp()
    }
  },
  created() {
    this.loadCity()
    const that = this
    // setTimeout(function () {
    //   that.chooseIndex(that.siteDetail)
    // }, 1000)
  },
}
</script>
<style lang="scss" scoped>
.roll {
  height: 550px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.town {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.town:after {
  content: '';
  width: 100px;
}
/deep/ .van-tag--default {
  width: 85px;
  font-size: 20px;
  padding: 5px;
  text-align: center !important;
  display: block;
  margin-bottom: 8px;
  border: 1px solid #999;
}
</style>